module.exports = __webpack_public_path__ + "img/AUT.8d529cb3.svg";